import { ExternalLink, Globe2, Mail, ShieldCheck } from 'lucide-react';
import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useApp } from '../domain/AppContext';
import { Dialog } from './ui';

export function InstitutionalFooter() {
  const { profile } = useApp();
  const location = useLocation();
  const [creditsOpen, setCreditsOpen] = useState(false);
  const isPrivacyPage = location.pathname === '/privacidade';
  const contextClass = profile
    ? profile.role === 'student'
      ? 'institutional-footer-student'
      : 'institutional-footer-collaborator'
    : 'institutional-footer-public';

  return (
    <footer className={`institutional-footer ${contextClass}`} aria-label="Informações institucionais">
      <span className="institutional-footer-copy">
        <span className="institutional-footer-legal">© 2026 Colégios Univap. Todos os direitos reservados.</span>
        <span className="institutional-footer-environment">
          <ShieldCheck size={13} aria-hidden="true" />
          Ambiente institucional · acesso monitorado
        </span>
      </span>
      <nav aria-label="Links institucionais">
        <button className="institutional-footer-link" type="button" onClick={() => setCreditsOpen(true)}>
          <Globe2 size={14} aria-hidden="true" />
          Sobre este projeto
        </button>
        {isPrivacyPage ? (
          <Link to={profile ? '/dashboard' : '/login'}>
            <ShieldCheck size={14} aria-hidden="true" />
            Voltar ao sistema
          </Link>
        ) : (
          <Link to="/privacidade">
            <ShieldCheck size={14} aria-hidden="true" />
            Políticas de Privacidade
          </Link>
        )}
      </nav>
      <Dialog
        open={creditsOpen}
        title="Sobre este projeto"
        description="Projeto autoral"
        onClose={() => setCreditsOpen(false)}
        size="small"
      >
        <div className="project-credits">
          <p>Plataforma planejada e desenvolvida por Guibson Valerio.</p>
          <div className="project-credits-links" aria-label="Links de autoria">
            <a href="https://guibson.com.br" target="_blank" rel="noopener noreferrer">
              <ExternalLink size={17} aria-hidden="true" />
              <span>Conheça Guibson Valerio</span>
            </a>
            <a href="mailto:guibsonv@icloud.com">
              <Mail size={17} aria-hidden="true" />
              <span>Fale com o desenvolvedor<small>guibsonv@icloud.com</small></span>
            </a>
          </div>
        </div>
      </Dialog>
    </footer>
  );
}
